import React from 'react'
import {
    Card,
    CardContent,
    Grid,
    Icon,
    Typography,
} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';
import classNames from 'classnames'
import _ from 'lodash'
import { joinPaths } from 'src/common/razzle-platform-components/utils'
import { useIntl } from 'src/common/razzle-platform-translate'
import {BASE_URL} from 'src/common/razzle-platform-map/configs'
import { LazyLoadImage } from 'react-lazy-load-image-component'



export function DefaultListItem(props) {
    const { item, isHovered } = props
    const { formatMessage } = useIntl()

    const fillRating = (value, filledElement, emptyElement, halfFilledElement) => {
        const elements = []
        const numberOfElement = 5
        const isInt = value % 1 === 0

        for (let i = 0; i < numberOfElement; i++) {
            if (i < (value | 0)) {
                elements.push(filledElement)
            } else {
                if(!isInt && (value % 1 > 0.4) && (i < value)){
                    elements.push(halfFilledElement)
                }else{
                    elements.push(emptyElement)
                }
            }
        }

        return elements
    }


    return (
        <Card
            elevation={0}
            data-item-id={item.id}
            style={{boxShadow: isHovered ? '0 0 4px 3px #dcdcdc' : '', height: 250}}
            className={classNames('m-4 rounded border border-solid border-gray-300 cursor-pointer',)}

        >
            <CardContent>
                <Grid container>
                    <Grid item xs={12} md={4} container justify="center">
                        <LazyLoadImage
                            alt={item.name}
                            effect="blur"
                            height="auto"
                            src={!_.isEmpty(item.images) ? joinPaths(BASE_URL, item.images[0].url) : '/images/item_background_for_map.png'}
                            placeholderSrc={!_.isEmpty(item.images) ? joinPaths(BASE_URL, item.images[0].url) : '/images/item_background_for_map.png'}
                            width="90%"
                            className="mb-4 object-contain"
                            style={{maxHeight: '10rem'}}
                        />
                    </Grid>
                    <Grid container item xs={12} md={8} alignItems="center">
                        <Grid item xs={12}>
                            <Typography variant="h6" className="break-words"> {item.name} </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" className="mb-2"> {_.truncate(item.description, { length: 70 })} </Typography>
                        </Grid>
                        <Grid container className="mt-2">
                            {item.reviews_score &&
                                <Grid item container alignItems="center" alignContent="center" justify="flex-end" xs={12}>
                                    <Grid container className="flex" item alignItems="center" alignContent="center">
                                        {
                                            fillRating(
                                                item.reviews_score,
                                                <Icon style={{ color: '#ffea00', fontSize: '1.2rem' }}>star</Icon>,
                                                <Icon style={{ color: '#a5a5a5', fontSize: '1.2rem' }}>star_border</Icon>,
                                                <Icon style={{ color: '#ffea00', fontSize: '1.2rem' }}>star_half</Icon>
                                            )
                                        }
                                    </Grid>
                                    <Grid item>
                                        {/* <Typography className="ml-1"> {`${product.reviews_score} (${product.reviews.length})`} </Typography> */}
                                    </Grid>
                                </Grid>
                            }
                            <Grid container item xs={6} justify="flex-end">
                                <Typography className="text-green-600 font-semibold text-xl"> {item.price} {formatMessage({ id: '€', defaultMessage: '€' })} </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}



export function DefaultSkeletonItem(props) {
    const { item } = props

    return (
        <Card
            elevation={0}
            item_id={item.id}
            style={{height: 170}}
            className={classNames('m-4 rounded border border-solid border-gray-300 cursor-pointer',)}
        >
            <CardContent>
                <Grid container>
                    <Grid item xs={12} md={4} container justify="center">
                        <Skeleton animation="wave" variant="rect" width="90%" height="200px" />
                    </Grid>
                    <Grid container item xs={12} md={8} alignItems="center">
                        <Grid item xs={12}>
                            <Typography variant="h6" className="break-words">
                                <Skeleton />
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" className="mb-2">
                                <Skeleton animation="wave" />
                            </Typography>
                            <Typography variant="body1" className="mb-2">
                                <Skeleton animation="wave" />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

